module.exports = __webpack_public_path__ + "img/evenements_titre.5fa486a0.png";